<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
        Prix d'une unité {{ uniteEngrais.libelle }}
      </div>

      <v-btn
        class="align-self-center"
        text
        @click="onClose()"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div class="d-flex mt-6 mx-4">
      <AgrialInputNumber
        v-model.number="uniteEngraisModifiable.prixEnEuroUnite"
        :label="`Prix d\'une unité ${uniteEngrais.libelle} ${uniteEngrais.statut === 'OBLIGATOIRE' ? '*' : ''}`"
        :suffix="uniteEngrais.libelle === 'CaO' ? '€/kg' : '€/unité'"
        :rules="[rules.positif]"
        min="0"
      />
    </div>
    <div class="my-2 ml-5 action texte-gris-fonce">
      * Champ obligatoire
    </div>
    <div class="d-flex justify-space-between mx-5 mt-4">
      <AgrButton
        class="pa-5"
        outlined
        @click="onClose()"
      >
        Annuler
      </AgrButton>
      <AgrButton
        :disabled="!isValid"
        class="pa-5"
        @click="save()"
      >
        Valider
      </AgrButton>
    </div>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import AgrialInputNumber from '@/components/form/agrial-input-number.vue'
import { mapActions } from 'vuex'
import {clone} from '@/utils/clone'

export default {
  name: 'UpdatePrixModal',
  components: {AgrButton, AgrialInputNumber},
  props: {
    uniteEngrais: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      uniteEngraisModifiable: null,
      erreur: null,
      rules: {
        required: value => (value !== null && value !== '') || 'Champ requis',
        positif: value => (value != null && value >= 0) || 'Doit être >= 0'

      }
    }
  },

  computed: {  
    isValid () {
      return this.uniteEngraisModifiable.statut !== 'OBLIGATOIRE' || (this.uniteEngraisModifiable.statut === 'OBLIGATOIRE' && this.uniteEngraisModifiable.prixEnEuroUnite != null && this.uniteEngraisModifiable.prixEnEuroUnite >= 0)
    }
  },

  created () {
    this.uniteEngraisModifiable = clone(this.uniteEngrais)
  },

  methods: {
    ...mapActions({
      createOrUpdateAdminComparateurMargeUnitesEngrais: 'comparateurMarge/createOrUpdateAdminComparateurMargeUnitesEngrais'
     }),
    save () {
      this.createOrUpdateAdminComparateurMargeUnitesEngrais(this.uniteEngraisModifiable)
      .then(() => this.$emit('save'))
    },
    onClose () {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}

.input-number {
  width: 100%;
}
</style>
